module.exports = __webpack_public_path__ + "src/assets/img/share/tips/open/fc3957239b4f8f1bd916ae4e525c6ca0.png";